import SendMail from '../components/PwRecovery/SendMail'
import VerifyCode from '../components/PwRecovery/VerifyCode'
import InputPwRecovery from '../components/PwRecovery/InputPwRecovery'
import SuccessPwRecovery from '../components/PwRecovery/SuccessPwRecovery'

export default [
  {
    path: '/pwrecovery',
    name: 'Send Mail',
    component: SendMail
  },
  {
    path: '/pwrecovery/verify',
    name: 'Verify Code',
    component: VerifyCode
  },
  {
    path: '/pwrecovery/input',
    name: 'Input Password Recovery',
    component: InputPwRecovery
  },
  {
    path: '/pwrecovery/success',
    name: 'Success Password Recovery',
    component: SuccessPwRecovery
  }
]
